import React from 'react';
import { withRouter } from 'react-router-dom';
import { Doughnut } from 'react-chartjs-2';
import moment from 'moment';
import { Grid } from './../../../../themes/default';
import { Legend } from './../../../../components/includes/ui';
import { CardDefault } from './../../../../components/includes/card';
import { Dropdown } from './../../../../components/includes/dropdown';
import { SnackbarStatic } from './../../../../components/includes/snackbar';
import { WheelService } from './../../../../services';
import { getPercentaje, getReversePercentage } from './../../../../utilities/utils';
import localStorageToken from './../../../../utilities/storage';
import ThemeCustom from './../../../../themes/custom';

import API from './../../../../config/api';

class WhellReport extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      report: null,
      dates: null,
      loading: false,
      error: false
    };
  }

  componentDidMount(){
    this._Find();
  }

  /*
  ** @Service
  ** @Description: Find Report
  */

  _Find = () => {

    WheelService.reportAll().then((response) => {

      this.setState({
        loading: true,
        report: response,
        dates: `${ moment(response.start).format('D MMMM, YYYY') } — ${ moment(response.end).format('D MMMM, YYYY') }`
      });

    }).catch((error) => {

      this.setState({ loading: true, error: true });

    });

  }

  /*
  ** @Event
  ** @Description: Export
  */

  handleExportToCSV = () => {
    window.open(`${ API.endpoint.services }/action/wheel/awards/export/${ localStorageToken().replace(/["']/g, '') }`);
  }

  render() {

    const { loading, error, report, dates } = this.state;

    const legend = { display: false };

    const data = {
      options: {
        layout: {
            padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            }
        }
      },
    	labels: [
    		'Convertidos',
    		'Total'
    	],
    	datasets: [{
    		data: [
          this.state.report ? this.state.report.leads : 0,
          this.state.report ? this.state.report.total : 0
        ],
    		backgroundColor: [
      		ThemeCustom.palette.success.main,
      		ThemeCustom.palette.warning.main
    		]
    	}]
    };

    return (
        loading && (
          <CardDefault
            title="Ruleta"
            subheader={ dates }
            action={
              <Dropdown items={
                  [
                    { label: 'Exportar', event: () => { this.handleExportToCSV() } }
                  ]
                }
              />
            }
          >
            <Grid container spacing={8} justify="center" alignItems="center">

              { !error ? (
                <React.Fragment>
                  <Grid item lg={4} md={6} sm={12} xs={12}>
                    <Doughnut data={ data } legend={ legend }/>
                  </Grid>
                  <Grid item lg={8} md={6} sm={12} xs={12}>
                    { report && (
                      <React.Fragment>
                        <Legend
                          variant="success"
                          text={`${ getPercentaje(report.leads, report.total) }% Convertidos (${ report.leads })`}
                        />
                        <Legend
                          variant="warning"
                          text={`${ getReversePercentage((report.total - report.leads), report.total) }% Restantes (${ report.total - report.leads })`}
                        />
                        <Legend
                          variant="info"
                          text={`100% Total (${ report.total })`}
                          disableGutters
                        />
                      </React.Fragment>
                    )}
                  </Grid>
                </React.Fragment>
              ) : (
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <SnackbarStatic
                    icon="info"
                    variant="warning"
                    message="Hubo un error interno, por favor intenta más tarde."
                    open={true}
                    fullWidth hideClose/>
                </Grid>
              )}

            </Grid>
          </CardDefault>
        )
      )
    }

}

export default withRouter(WhellReport);
